import { motion } from 'framer-motion';

/**
 * Loading screen component
 * Displayed while 3D scene loads
 */
export function LoadingScreen(): React.JSX.Element {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-b from-aviator-skyDark to-aviator-sky">
      {/* Animated plane icon */}
      <motion.div
        animate={{
          y: [0, -10, 0],
          rotate: [-5, -3, -5],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        className="mb-8"
      >
        <svg
          width="80"
          height="60"
          viewBox="0 0 200 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Fuselage */}
          <ellipse cx="100" cy="50" rx="70" ry="15" fill="#dc2626" />
          {/* Cockpit */}
          <ellipse cx="160" cy="48" rx="15" ry="10" fill="#60a5fa" />
          {/* Main wing */}
          <path d="M70 50 L30 30 L30 35 L70 55 Z" fill="#b91c1c" />
          <path d="M70 50 L30 70 L30 65 L70 55 Z" fill="#b91c1c" />
          {/* Tail wing vertical */}
          <path d="M35 50 L20 25 L25 25 L40 50 Z" fill="#b91c1c" />
          {/* Tail wing horizontal */}
          <path d="M35 50 L20 40 L20 45 L35 52 Z" fill="#991b1b" />
          <path d="M35 50 L20 60 L20 55 L35 52 Z" fill="#991b1b" />
          {/* Engine */}
          <ellipse cx="165" cy="50" rx="8" ry="5" fill="#1e3a5f" />
          {/* Windows */}
          <circle cx="140" cy="47" r="3" fill="#60a5fa" />
          <circle cx="125" cy="47" r="3" fill="#60a5fa" />
          <circle cx="110" cy="47" r="3" fill="#60a5fa" />
        </svg>
      </motion.div>

      {/* Title */}
      <h1 className="mb-4 text-4xl font-bold text-aviator-plane">AVIATOR</h1>
      <p className="mb-6 text-white/60">CRASH GAME</p>

      {/* Loading bar */}
      <div className="relative h-1.5 w-48 overflow-hidden rounded-full bg-aviator-skyDark/50">
        <motion.div
          animate={{ x: ['-100%', '100%'] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          className="absolute inset-y-0 w-1/3 rounded-full bg-gradient-to-r from-aviator-plane to-red-400"
        />
      </div>

      <p className="mt-4 text-sm text-white/40">Loading game assets...</p>
    </div>
  );
}
